import builder from '../builder';
import DoorLock from '../../streamline-icons/bold/door-lock.svg';

export default builder('IconDoorLockBold', DoorLock);
